import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const ShareFinancesSeparate: FC<IconSVGComponentProps> = ({
    ...props
}) => {
    return (
        <IconSVG
            width="60px"
            height="29px"
            viewBox="0 0 60 29"
            fill="none"
            {...props}
        >
            <path
                d="M27.2809 14.4324C27.2809 21.9577 21.1804 28.0582 13.6551 28.0582C6.12977 28.0582 0.0292969 21.9577 0.0292969 14.4324C0.0292969 6.90711 6.12977 0.806641 13.6551 0.806641C21.1804 0.806641 27.2809 6.90711 27.2809 14.4324Z"
                fill="#CF7135"
                style={{ fill: 'color(display-p3 0.8118 0.4431 0.2078)' }}
                fillOpacity={1}
                strokeWidth={0}
            />
            <path
                d="M59.7457 14.4324C59.7457 21.9577 53.6452 28.0582 46.1199 28.0582C38.5946 28.0582 32.4941 21.9577 32.4941 14.4324C32.4941 6.90711 38.5946 0.806641 46.1199 0.806641C53.6452 0.806641 59.7457 6.90711 59.7457 14.4324Z"
                fill="#6DBBF3"
                style={{ fill: 'color(display-p3 0.4275 0.7333 0.9529)' }}
                fillOpacity={1}
                strokeWidth={0}
            />
        </IconSVG>
    );
};
